import { createRouter, createWebHistory } from 'vue-router'
import Introduction from '../views/Introduction.vue'
import APTMap from '../views/APTMap.vue'
import ClusterProfiles from '../views/ClusterProfiles.vue'
import Base from '../views/Base.vue'

const routes = [
  {
    path: '/',
    redirect: '/introduction'
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction
  },
  {
    path: '/apt-map',
    name: 'APTMap',
    component: APTMap
  },
  {
    path: '/cluster-profiles',
    name: 'ClusterProfiles',
    component: ClusterProfiles
  },
  {
    path: '/base',
    name: 'Base',
    component: Base
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
